/**
 * The terminal ("máquina") contract.
 *
 * A terminal is a betting machine installed at a location, identified to Kambi by the YubiKey
 * plugged into it. `maquinas.location_id` is `not null` in the database — a terminal without a
 * location is not a state this table can hold — so every terminal payload here is read and
 * written in the context of one location; there is no route that lists every terminal across
 * every location, matching the legacy dashboard's own `locations.tsx`, where a terminal was
 * always a nested part of a location's own detail view.
 *
 * `maquinas.yubikey` is a plain unique text column, not a declared foreign key — the schema
 * comment on `yubikeys` notes the pool's own primary identity is `serial_number`, and nothing in
 * the database enforces that a terminal's `yubikey` value names a row that exists. The service
 * layer is where that reference is checked, the same way `noticias.slug` uniqueness is checked
 * in code rather than left to a constraint the legacy table never had either.
 */
import { z } from 'zod';
import { nonEmptyUpdate } from './content/common.js';
const maquinaEditableShape = {
    yubikey: z.string().min(1),
    yubikeyNumber: z.string().min(1),
    modelo: z.string().min(1),
    nombre: z.string().min(1).nullable(),
    estado: z.string().min(1),
    notas: z.string().min(1).nullable(),
};
export const maquinaSchema = z.object({
    id: z.number().int().positive(),
    locationId: z.number().int().positive(),
    ...maquinaEditableShape,
    createdAt: z.iso.datetime(),
    updatedAt: z.iso.datetime(),
});
export const maquinaListSchema = z.array(maquinaSchema);
/** `locationId` is not here: it comes from the route the terminal is created under. */
export const createMaquinaSchema = z.object(maquinaEditableShape).extend({
    nombre: maquinaEditableShape.nombre.optional(),
    estado: maquinaEditableShape.estado.optional(),
    notas: maquinaEditableShape.notas.optional(),
});
export const updateMaquinaSchema = nonEmptyUpdate(z.object(maquinaEditableShape));
//# sourceMappingURL=maquinas.js.map